/**
 * Block loader adapter — re-exports from @cogo/runtime-v2 for convenience.
 */

export { loadBlock, isV2Block, V2_FILES } from "@cogo/runtime-v2"
export type { FileReader } from "@cogo/runtime-v2"
